import { inputResult } from "../Submit/SaveAnswer";


export function transformOrToSelf(input:JQuery, results:inputResult, points:number, possible:number){
    
    // Do nothing

}